import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import dataV from '@jiaminghi/data-view'
import echarts from 'echarts'

import './assets/iconfont/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import filters from "./filters";
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

import urls from './api/urls'
import {
  getData,
  putData,
  postData,
  patchData,
  deleteData
} from './api/'
import {getArr, timeToTimeAll} from './common/'

Vue.prototype.urls = urls
Vue.prototype.getData = getData
Vue.prototype.putData = putData
Vue.prototype.postData = postData
Vue.prototype.patchData = patchData
Vue.prototype.deleteData = deleteData
Vue.prototype.getArr = getArr
Vue.prototype.timeToTimeAll = timeToTimeAll

Vue.prototype.$echarts = echarts
Vue.prototype.webSockHref = "ws://124.70.182.47:9503";

Vue.config.productionTip = false
Vue.use(dataV)
Vue.use(ElementUI)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')